import * as Sentry from '@sentry/react';

export class Logger {
  static init() {
    Sentry.init({
      dsn: import.meta.env.VITE_SENTRY_DSN,
      environment: import.meta.env.VITE_APP_ENV,
      release: import.meta.env.VITE_APP_VERSION,
    });
  }

  static enrichUser(user: Sentry.User) {
    Sentry.setUser({
      id: user.id,
      email: user.email,
      name: user.name,
    });
  }

  static log(message: string) {
    Sentry.captureMessage(message);
  }

  static logError(error: Error) {
    Sentry.captureException(error);
  }

  static logErrorWithContext(error: Error, context: Record<string, unknown>) {
    Sentry.captureException(error, {
      extra: context,
    });
  }
}
